export default __webpack_public_path__ + "static/media/ic-field-arrow-down.c357bc53.svg";